var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDefender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_4433)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_200_4433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 17.9821L8.81499 17.9064C7.16986 17.2327 3.94306 15.1198 1.92015 12.5319C0.649802 10.9027 0.00585938 9.30781 0.00585938 7.79113V2.99857C0.00585938 2.59054 0.357232 2.25863 0.789139 2.25863H2.15761C3.47165 2.25863 4.15766 1.81128 4.95194 1.29326C5.87237 0.693025 6.91567 0.0126953 8.99984 0.0126953C11.084 0.0126953 12.1273 0.693025 13.0477 1.2933C13.8421 1.81128 14.5281 2.25867 15.8422 2.25867H17.2106C17.6425 2.25867 17.9939 2.59059 17.9939 2.99862V7.79108C17.9939 9.30781 17.3499 10.9027 16.0799 12.5315C14.0566 15.1199 10.8298 17.2327 9.18474 17.9064L8.99984 17.9821ZM0.938455 3.14315V7.79108C0.938455 9.11437 1.52094 10.5323 2.66967 12.0055C4.51561 14.367 7.40302 16.3057 8.99984 17.0153C10.5966 16.3057 13.484 14.367 15.3303 12.0051C16.4788 10.5323 17.0612 9.11437 17.0612 7.79108V3.14315H15.8421C14.2383 3.14315 13.3644 2.57325 12.5193 2.02211C11.6322 1.44363 10.7942 0.897216 8.99984 0.897216C7.20539 0.897216 6.36746 1.44363 5.48033 2.02215C4.63522 2.57329 3.76128 3.14319 2.15756 3.14319L0.938455 3.14315Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41946 0.455078H8.58008V17.5005H9.41946V0.455078Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4577 8.20068H0.54248V9.04098H17.4577V8.20068Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_4433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_200_4433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDefender);
export default __webpack_public_path__ + "static/media/ic_defender.6ca1d1e52f29a66fa30992b6b13acf02.svg";
export { ForwardRef as ReactComponent };